import { render, staticRenderFns } from "./NewTeacherInstituteTerms.vue?vue&type=template&id=3811d3cd&scoped=true"
import script from "./NewTeacherInstituteTerms.vue?vue&type=script&lang=js"
export * from "./NewTeacherInstituteTerms.vue?vue&type=script&lang=js"
import style0 from "./NewTeacherInstituteTerms.vue?vue&type=style&index=0&id=3811d3cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3811d3cd",
  null
  
)

export default component.exports